module.exports = __webpack_public_path__ + "img/result-score.331e90ae.png";